import React from "react";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import "../assets/css/bootstrap.min.css";
import "../assets/css/icons.min.css";
import "../assets/libs/simplebar/simplebar.min.css";
import "../assets/css/app.min.css";
import AuthLayout from "../components/auth/AuthLayout";
import LogoBlock from "../components/auth/LogoBlock";
import LoginForm from "../components/auth/LoginForm";

function Login() {
  return (
    <AuthLayout>
      <LogoBlock />
      <LoginForm />
      <div className="mt-5 text-center">
        <p>
          © {new Date().getFullYear()} Hub Business Center. Handcrafted with
          <i className="mdi mdi-heart text-danger"></i>By Insasoft
        </p>
      </div>
    </AuthLayout>
  );
}
export default Login;
